import { render, staticRenderFns } from "./MetatraderAccountHistory.vue?vue&type=template&id=af80a1ec"
import script from "./MetatraderAccountHistory.vue?vue&type=script&lang=js"
export * from "./MetatraderAccountHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports